import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: {
            noNeedHeader: false, // 此頁面是否不需要 header bar
            breadcrumb: [{ name: '首頁' }]
        },
        component: () => import('../views/Home.vue')
    },
    {
        path: '/order',
        name: 'order',
        meta: {
            noNeedHeader: false, // 此頁面是否不需要 header bar
            breadcrumb: [{ name: '首頁', link: '/' }, { name: '線上訂車' }]
        },
        component: () => import('../views/order/index.vue'),
        children: [
            {
                path: '',
                name: 'service',
                meta: {
                    noNeedHeader: false, // 此頁面是否不需要 header bar
                    breadcrumb: [{ name: '首頁', link: '/' }, { name: '線上訂車' }]
                },
                component: () => import('../views/service/index.vue')
            },
            {
                path: 'pickup',
                name: 'pickup',
                meta: {
                    noNeedHeader: false, // 此頁面是否不需要 header bar
                    breadcrumb: [{ name: '首頁', link: '/' }, { name: '線上訂車', link: '/order' }, { name: '接送服務' }]
                },
                component: () => import('../views/pickup/index.vue')
            },
            {
                path: 'charter',
                name: 'charter',
                meta: {
                    noNeedHeader: false, // 此頁面是否不需要 header bar
                    breadcrumb: [{ name: '首頁', link: '/' }, { name: '線上訂車', link: '/order' }, { name: '包車服務' }]
                },
                component: () => import('../views/charter/index.vue')
            }
        ]
    },
    {
        path: '/qa',
        name: 'qa',
        meta: {
            noNeedHeader: false, // 此頁面是否不需要 header bar
            breadcrumb: [{ name: '首頁', link: '/' }, { name: '常見問題' }]
        },
        component: () => import('../views/qa/index.vue')
    },
    {
        path: '/track',
        name: 'track',
        meta: {
            noNeedHeader: false, // 此頁面是否不需要 header bar
            breadcrumb: [{ name: '首頁', link: '/' }, { name: '訂單查詢' }]
        },
        component: () => import('../views/tracking/index.vue')
    },
    {
        path: '/suggest',
        name: 'suggest',
        meta: {
            noNeedHeader: false, // 此頁面是否不需要 header bar
            breadcrumb: [{ name: '首頁', link: '/' }, { name: '評價司機' }]
        },
        component: () => import('../views/suggest/index.vue')
    },
    {
        path: '*',
        redirect: '/'
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

export default router;
